import React from "react";

const CustomLogoImage = ({ src, className, id, alt, referrerpolicy }) => {
  return (
    <img
      src={src}
      className={className}
      id={id}
      alt={alt}
      referrerpolicy={referrerpolicy}
    />
  );
};

export default CustomLogoImage;
